'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);

/**
 * Base class for question.
 *
 * @export
 * @class QuestionBase
 * @template T
 */
var QuestionBase = /*#__PURE__*/_createClass__default["default"](function QuestionBase() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  _classCallCheck__default["default"](this, QuestionBase);
  this.value = options.value;
  this.key = options.key || '';
  this.label = options.label || '';
  this.disabled = !!options.disabled;
  this.required = !!options.required;
  this.controlType = options.controlType || '';
  this.placeholder = options.placeholder || '';
  this.variableType = options.variableType || '';
  this.usingNullParam = !!options.usingNullParam;
});

exports.QuestionBase = QuestionBase;
